import React from 'react';
import { TimelineItem, TimelineRegistry } from 'framework/ui/timeline';
import CreateStaffingNoteForm from 'domain/staffing/dashboard/dashboard/shared/staffingContent/notes/CreateStaffingNoteForm';
import StaffingNoteTimelineRecordLayout from './StaffingNoteTimelineRecordLayout';
import StaffingNoteTimelineUpdateForm from './StaffingNoteTimelineUpdateForm';
import type { Data } from 'framework/types';

export const STAFFING_NOTE_SOURCE = 'staffingNote';

interface StaffingNoteRegistryOptions {
  refetch?: () => Promise<void>;
}

const AddStaffingNoteForm = (props: any) =>
  React.createElement(CreateStaffingNoteForm, {
    ...props,
    onCancel: props.onCancel ?? (() => {}),
  });

const useStaffingNoteTimelineRegistry = (options: StaffingNoteRegistryOptions = {}): TimelineRegistry => {
  const { refetch } = options;
  return {
    name: 'Note',
    AddForm: AddStaffingNoteForm,
    UpdateForm: StaffingNoteTimelineUpdateForm as unknown as React.ReactElement,
    RecordLayout: StaffingNoteTimelineRecordLayout as unknown as React.ReactElement,
    isApplicable: (item: TimelineItem) => !!(item as Record<string, unknown>)?.[STAFFING_NOTE_SOURCE],
    source: STAFFING_NOTE_SOURCE,
    urlPostfix: 'notes',
    additionalAfterAddSubmit: refetch
      ? (_data: TimelineItem, _parentContext?: Data, _reloadData?: () => void) => {
          refetch();
        }
      : undefined,
  };
};

export default useStaffingNoteTimelineRegistry;
